import script from "./Admin.vue?vue&type=script&lang=ts&setup=true"
export * from "./Admin.vue?vue&type=script&lang=ts&setup=true"

import "./Admin.vue?vue&type=style&index=0&id=70c46af8&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c46af8"]])

export default __exports__